import Vue from 'vue';
import Router from 'vue-router';
import store from './store/index';
import ActionPage from './views/ActionPage';
import BinNumberPage from './views/BinNumberPage';
import HomePage from './views/HomePage';
import LoginPage from './views/LoginPage';
import SearchPage from './views/SearchPage';
import ResultsPage from './views/ResultsPage';
import EditCustomerPage from './views/EditCustomerPage';
import AgreementPage from './views/AgreementPage';
import NewCustomerPage from './views/NewCustomerPage';
import TransactionPage from './views/TransactionPage';
import ReceiptPage from './views/ReceiptPage';
import OfferPage from './views/OfferPage';
import BuyOfferPage from './views/BuyOfferPage';
import DropoffDecisionPage from './views/DropoffDecisionPage';
import TagsPage from './views/TagsPage';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/action'
    },
    {
      path: '/action',
      name: 'action',
      component: ActionPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/dropoff_decision',
      name: 'dropoff_decision',
      component: DropoffDecisionPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/bin_number',
      name: 'bin_number',
      component: BinNumberPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/tags',
      name: 'tags',
      component: TagsPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter(to, from, next) {
        store.dispatch('auth/logout');
        next('/login');
      },
    },
    {
      path: '/home',
      name: 'home',
      component: HomePage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/search',
      name: 'search',
      component: SearchPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/search-results',
      name: 'search-results',
      component: ResultsPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/edit-customer',
      name: 'edit-customer',
      component: EditCustomerPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/new-customer',
      name: 'new-customer',
      component: NewCustomerPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/tos',
      name: 'tos',
      component: AgreementPage,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/transaction',
      name: 'transaction',
      component: TransactionPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/receipt',
      name: 'receipt',
      component: ReceiptPage,
      meta: {
        requiresAuth: true
      },
    },
    // Note! This route is ONLY accessible when unauthenticated. If you attempt to navigate to this route with
    //  an authenticated session then the browser will be redirected to the home path.

    {
      path: '/trade-offer/:id',
      name: 'trade-offer',
      component: OfferPage,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/buy-trade-offer/:id',
      name: 'buy-trade-offer',
      component: BuyOfferPage,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Check if matched routes require auth
  const isProtected = to.matched.some((record) => record.meta.requiresAuth);
  // Does not require auth and user is not loggeed in: proceed
  if (!isProtected && !store.getters['auth/isLoggedIn']) {
    next();
    return;
  }
  // Requires auth and user is loggeed in: proceed
  if (isProtected && store.getters['auth/isLoggedIn']) {
    next();
    return;
  }
  // Does not require auth and user is loggeed in: back to home
  if (!isProtected && store.getters['auth/isLoggedIn']) {
    next('/action');
    return;
  }
  // Deny
  next('/login');
});

export default router;
